
import MetaSEO from '../components/MetaSEO/MetaSEO';
import Header from '../components/Sweepstakes/Header/Header';
import Spotlight from '../components/Sweepstakes/Spotlight';
import Offer from '../components/Offer/Offer';
import Footer from '../components/Footer/Footer';


import '../styles/styles.scss';

export default function Sweepstakes({appleUrl, androidUrl}) {

    appleUrl = "https://pawpatrolacademyappstore.onelink.me/8QSn/4l43j083";
    androidUrl = "https://pawpatrolacademyandroid.onelink.me/f1Ym/xj2xxs1a";

    return (
        <>
        <MetaSEO 
            title="Yelp For Help Sweepstakes Contest | PAW Patrol Academy | Preschool Learning App | iOS & Android"
            canonical="https://www.pawpatrolacademy.com/"
            description="PAW Patrol Academy has a special message for stressed-out parents of preschoolers. In addition to trusted, age-appropriate learning content for your little ones, 
                    we're offering  $2,500 in gift card cash and prizes to help you achieve your goals. "
            keywords="Sweepstakes, contest, cash, free subscription, Learning App, Learning games, Education App, ABC, Coloring app, Alphabet, Spelling, Academy,Preschool app,Playtime,Fun,Adventure,Shapes,Music,Dance,Kindergarten app,Chase,Skye, Rubble, The Lookout,Paw patrol"    
            type="webapp"
            name="Originator Kids | Spin Master"
        />
        <div className="site-container">
            <Header appleUrl={appleUrl} androidUrl={androidUrl} pageMode="landing-page"/>
            <Spotlight appleUrl={appleUrl} androidUrl={androidUrl}/>
            <Offer appleUrl={appleUrl} androidUrl={androidUrl} />
            <div className="spacer-generic">&nbsp;</div>
            <Footer hideKidSafe={true} />
        </div>
        </>

    )
}